import {clientCompanyLogoEnpoints} from '@configuration';

export async function uploadImage(image: File): Promise<void> {
    await clientCompanyLogoEnpoints.updateCompanyLogo({file: image});
}
